import { useCallback } from 'react'
import { useTranslation } from 'react-i18next'
import ApiService from '../../services/ApiService'
import { confirmationAlert, showAlert } from '../../utility/SweetAlert'

const InteractorTransactionUpdate = () => {
  const { t } = useTranslation()
  const transactionUpdate = useCallback(
    (payload, loading, confirmationType) => {
      const { message, icon } = confirmationType
      confirmationAlert({
        message,
        icon,
      }).then(result => {
        if (result === true) {
          ApiService.jsonRequest('/transaction-order/update', payload, response => {
            loading(false)
            if (response.status_code === 200) {
              showAlert({
                icon: 'success',
                message: t('message.successfully_updated'),
                timer: 1500,
                redirect: '/transaction/manage',
              })
            } else {
              showAlert({
                icon: 'error',
                message: t(`response_message.${response.messages}`),
                timer: 1500,
              })
            }
          })
        } else {
          loading(false)
        }
      })
    },
    [t],
  )
  return { transactionUpdate }
}

export default InteractorTransactionUpdate
